import { getUrlParam } from 'core-components/helpers/url'

export const getUrlPartnerId = (): string => {
  return getUrlParam('pid') || ''
}
